module.exports = __webpack_public_path__ + "static/media/back-arrow.8b358c45.png";